<script>
import { onMount } from 'svelte';
import { getDominantColor } from './utils/getDominantColor.js';
import Record from './record.svelte';
import Audio from './audio.svelte';
import RequestDetail from './requestDetail.svelte';
import VoiceDetail from './voiceDetail.svelte';

export let data;

let dominantColor
let recordAnimationFrame
let gaugeAnimationFrame
let record
let recordContainer
let detail
let audio
let gauge
let currentTime = 0;
let duration;
let isTextOpen = false
let translation = ''

onMount(async () => {
  dominantColor = await getDominantColor(data.voice.thumbnail_url);
})

function rotateRecord() {
  if (record) {
    const rotation = `rotate(${(currentTime / duration) * 360}deg)`;
    translateRecord(rotation)
  }
  requestAnimationFrame(rotateRecord);
}
function gaugeStart() {
  if(gauge) {
    gauge.style.transition = 'width 1s linear';
    gauge.style.width = `${(currentTime / duration) * 100}%`;
  }
  requestAnimationFrame(gaugeStart);
}
function play() {
  audio.play()
  recordAnimationFrame = requestAnimationFrame(rotateRecord)
  gaugeAnimationFrame = requestAnimationFrame(gaugeStart)
}
function end() {
  cancelAnimationFrame(recordAnimationFrame)
  cancelAnimationFrame(gaugeAnimationFrame)
}
function toggleDetail() {
  isTextOpen = !isTextOpen
  translation = isTextOpen ? `translateY(-${detail.offsetHeight}px)` : '';
  recordContainer.style.transform = `${translation}`
}
function translateRecord(rotation) {
  record.style.transform = `${rotation}`.trim();
}
</script>

<div class="fixed top-0 right-0 bottom-0 left-0 z-0" style="background-color: {dominantColor};"></div>
<div class="fixed top-0 right-0 bottom-0 left-0 z-10">
  <div class="fixed top-0 left-0 z-20 w-full h-16 bg-gray-transparent flex items-center justify-between px-4">
    <a href="{data.back_url}" class="flex items-center justify-center w-10 h-10 bg-black bg-opacity-20 rounded-full hover:bg-opacity-40 no-underline">
      <i class="icon-arrow_left text-xl text-white"></i>
    </a>
    {#if !data.is_me}
      <a href="{data.request_url}" class="px-5 py-3 bg-site-purple-1 text-white rounded-3xl hover:bg-site-purple-2 no-underline cursor-pointer">
        リクエスト
      </a>
    {/if}
  </div>
  <div class="pt-16 w-full h-full flex items-center justify-center">
    <div bind:this={recordContainer} class="relative recordContainer">
      <Record
        bind:record={record}
        circleColor={dominantColor}
        iconPath={data.voice.thumbnail_url}
      />
      <div class="absolute top-0 flex items-center justify-center w-[408px] h-[408px] mid:w-[556px] mid:h-[556px]">
        <button
          on:click={play}
          class="w-[9%] aspect-square flex items-center justify-center"
          aria-label="Play">
          <i class="icon-play_fill text-2xl text-white mid:text-4xl"></i>
        </button>
      </div>
    </div>
  </div>
  {#if data.fan}
    <RequestDetail
      bind:detail={detail}
      {isTextOpen}
      iconPath={data.fan.avatar_image_url}
    >
      <span slot="name">{data.fan.name}</span>
      <span slot="detail">{data.comment}</span>
    </RequestDetail>
    <button type="button" on:click={toggleDetail} class="fixed bottom-[136px] left-1/2 -translate-x-1/2 mx-auto px-4 py-2 text-xs font-bold text-white bg-white bg-opacity-20 hover:bg-opacity-40 rounded-3xl">
      依頼を表示
    </button>
  {/if}
  <VoiceDetail iconPath={data.creator.avatar_image_url}>
    <span slot="name">{data.creator.name}</span>
    <span slot="slug">@{data.creator.slug}</span>
    <span slot="title">{data.voice.title}</span>
  </VoiceDetail>
  <div class="fixed bottom-0 left-0 w-full h-1 bg-white">
    <div bind:this={gauge} class="h-1 bg-site-purple-1"></div>
  </div>
  <Audio
    bind:this={audio}
    bind:currentTime="{currentTime}"
    bind:duration={duration}
    voicePath={data.voice.audio_file_url}
    on:end={end}
  />
</div>

<style>
  .recordContainer {
    transition: transform .2s linear;
  }
</style>
